import React from 'react';
import { ContainerContact } from '../styles';

const Contact = () => {
    return ( 
        <ContainerContact id="contact">
            <h3>Contact Me</h3>
            <div> 
                <p>I am open to any proposal. My inbox will always be open, you can write to me either to ask me a question or just say hello, I will reply in the shortest time possible.</p>
            </div>
            <div>
                <a rel="noopener noreferrer" target="_blank" href="mailto:ojos1098@gmail.com">Say Hello</a>
            </div>
        </ContainerContact> 
    );
}
 
export default Contact;